/**
 * Centralized HTML sanitizer for any user-authored content rendered via
 * `dangerouslySetInnerHTML`. Blocks <script>, inline event handlers, javascript:
 * URLs and other XSS vectors while allowing rich Tiptap output.
 */
import DOMPurify from "isomorphic-dompurify";

const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "strong", "em", "u", "s", "del", "ins", "mark", "small", "sub", "sup",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "ul", "ol", "li",
    "blockquote", "code", "pre", "hr",
    "a", "img", "figure", "figcaption",
    "table", "thead", "tbody", "tr", "th", "td",
    "span", "div",
  ],
  ALLOWED_ATTR: ["href", "src", "alt", "title", "target", "rel", "class", "style"],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input"],
  FORBID_ATTR: ["onerror", "onclick", "onload", "onmouseover", "onfocus", "onblur"],
  ADD_ATTR: ["target", "rel"],
};

/** Returns a sanitized HTML string safe for `dangerouslySetInnerHTML`. */
export const sanitizeHtml = (dirty) => {
  if (!dirty || typeof dirty !== "string") return "";
  return DOMPurify.sanitize(dirty, CONFIG);
};

/** Convenience helper for React's dangerouslySetInnerHTML prop. */
export const safeHtml = (dirty) => ({ __html: sanitizeHtml(dirty) });
